import * as React from 'react';
export const baseSvg = React.forwardRef(function BaseSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('rect', {
      width: "32",
      height: "32",
      fill: "#F4F7FA",
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: "M3 5.054C3 4.35045 3 3.99868 3.13256 3.72808C3.25949 3.46899 3.46899 3.25949 3.72808 3.13256C3.99868 3 4.35045 3 5.054 3H26.946C27.6496 3 28.0013 3 28.2719 3.13256C28.531 3.25949 28.7405 3.46899 28.8674 3.72808C29 3.99868 29 4.35045 29 5.054V26.946C29 27.6496 29 28.0013 28.8674 28.2719C28.7405 28.531 28.531 28.7405 28.2719 28.8674C28.0013 29 27.6496 29 26.946 29H5.054C4.35045 29 3.99868 29 3.72808 28.8674C3.46899 28.7405 3.25949 28.531 3.13256 28.2719C3 28.0013 3 27.6496 3 26.946V5.054Z",
      fill: "#0000FF",
    }),
  );
});
baseSvg.defaultProps = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
};
export var base = {
  category: 'brand',
  colorable: false,
  name: 'base',
  svg: baseSvg,
};
